module.exports = __webpack_public_path__ + "img/cost-icon__pool_bar.7b67c14f.svg";